import { render } from "./index.vue?vue&type=template&id=092fb2c3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=092fb2c3&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092fb2c3"]])

export default __exports__